import { render, staticRenderFns } from "./Dialog_CreateSpecialClass.vue?vue&type=template&id=928c51d8&scoped=true&"
import script from "./Dialog_CreateSpecialClass.vue?vue&type=script&lang=js&"
export * from "./Dialog_CreateSpecialClass.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_CreateSpecialClass.vue?vue&type=style&index=0&id=928c51d8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "928c51d8",
  null
  
)

export default component.exports